// Module-scope cached dynamic import of ECharts.
// First caller (NgPrometPanel for Nova Gorica) triggers the chunk download;
// subsequent callers (Phase B NgArsoPanel) reuse the same Promise.

let echartsPromise: Promise<typeof import('echarts')> | null = null;

export function getEcharts(): Promise<typeof import('echarts')> {
  if (!echartsPromise) echartsPromise = import('echarts');
  return echartsPromise;
}
